<template xmlns="http://www.w3.org/1999/html">
  <div class="animated fadeIn" id="jira-worklogs">
    <div class="row">
      <div class="col-lg-12">
        <!-- <table>
                    <tr v-for="user in jiraWorklogs" :key="user.author_id">
                        {{user.author_id}}
                    </tr>
                </table> -->
        <!-- {{jiraWorklogs}} -->
        <div class="card">
          <div class="card-block">
            <div v-if="showActions">
              <div class="form-group row">
                <label class="col-form-label">Period from</label>
                <div class="col-md-3">
                  <datepicker placeholder="yyyy-mm-dd" input-class="worklogs-date-picker"
                    @change="changePeriodFromInput()" :disabled-dates="{ from: new Date(period.periodTo) }"
                    v-model="period.periodFrom" format="yyyy-MM-dd"></datepicker>
                </div>
                <label class="col-form-label">Period to</label>
                <div class="col-md-3">
                  <datepicker placeholder="yyyy-mm-dd" input-class="worklogs-date-picker"
                    @change="changePeriodToInput()" :disabled="!period.periodFrom"
                    :disabled-dates="{ to: new Date(period.periodFrom) }" v-model="period.periodTo" format="yyyy-MM-dd">
                  </datepicker>
                </div>
              </div>
              <!--<select v-model="currentTimeframe">-->
              <!--<option value="week">Week</option>-->
              <!--<option value="month">Month</option>-->
              <!--<option value="quarter">Quarter</option>-->
              <!--<option value="year">Year</option>-->
              <!--</select>-->
              <!--<div>-->
              <!--<button v-on:click="removeOneWeek">One period less</button>-->
              <!--<button v-on:click="increaseOffset">&larr;</button>-->
              <!--<button v-on:click="decreaseOffset">&rarr;</button>-->
              <!--<button v-on:click="addOneWeek">One period more</button>-->
              <!--</div>-->
              <div class="btn-group btn-group-sm mb-1">
                <!--<button class="btn" @click="showHours = !showHours" :class="showHours ? 'btn-success' : 'btn-info'">Logged hours</button>-->
                <!--<button class="btn" @click="showRateTime = !showRateTime" :class="showRateTime ? 'btn-success' : 'btn-info'">Hours * rate</button>-->
                <!--<button class="btn btn-success" @click="toggleHoursOrExpenses(hoursOrExpenses.type)" v-model="hoursOrExpenses">{{hoursOrExpenses.name}}</button>-->
                <button class="btn btn-success button-days" @click="toggleHoursOrExpenses(hoursOrExpenses.type)"
                  v-model="hoursOrExpenses"><span
                    :class="[hoursOrExpenses.type == 'hours' ? 'hours-enabled' : '']">Hours</span>/<span
                    :class="[hoursOrExpenses.type == 'rates' ? 'rates-enabled' : '']">Hours*Rate</span></button>
                <!--<button class="btn" @click="showTotalPlanned = !showTotalPlanned" :class="showTotalPlanned ? 'btn-success' : 'btn-info'">Planned time</button>-->
                <button data-toggle="button" v-for="button in periodPast" class="btn button-days" :key="button.name"
                  @click="changePeriodPast(button)"
                  :class="button.enabled ? 'btn-success' : 'btn-info'">{{ button.name }}</button>
                <button data-toggle="button" v-for="button in periodFuture" class="btn button-days" :key="button.name"
                  @click="changePeriodFuture(button)"
                  :class="button.enabled ? 'btn-success' : 'btn-info'">{{ button.name }}</button>
              </div>
            </div>
            <div class="table-view">
              <table class="table table-condensed table-sm">
                <thead>
                  <tr class="tr-full-width">
                    <td class="first-column">
                      User
                    </td>
                    <td v-for="date in calendar" class="table-data table-head-th"
                      :class="isCurrentWeek(date) ? 'curweek' : ''">
                      <div>{{ date.indexToView }}</div>
                      <div>{{ date.string }}</div>
                    </td>
                  </tr>
                  <!--<tr class="tr-full-width">-->
                  <!--&lt;!&ndash;<td class="first-column"></td>&ndash;&gt;-->
                  <!--<td v-for="date in calendar" class="table-data table-head-th" :class="isCurrentWeek(date) ? 'curweek' : ''">-->
                  <!--{{date.string}}-->
                  <!--</td>-->
                  <!--</tr>-->
                </thead>
                <tbody>
                  <WorklogsUserRow v-for="(logs, user) in jiraWorklogs" v-if="users[logs.user_id].enabled"
                    :plannedWorkloads="plannedWorkloads" :logs="logs" :userId="logs.user_id" :key="logs.user_id"
                    :showHours="showHours" :showRateTime="showRateTime" :showTotalPlanned="showTotalPlanned"
                    :allowExpanding="true" :timeframe="currentTimeframe" :showWorkloadPlanner="false">
                  </WorklogsUserRow>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import WorklogsUserRow from './WorklogsUserRow';

export default {
  name: 'Worklogs',
  components: {
    WorklogsUserRow,
    Datepicker
  },
  props: {
    projectId: {
      required: false
    },
    showActions: {
      type: Boolean,
      default: true
    },
  },
  data: function () {
    return {
      showHours: true,
      showRateTime: false,
      showTotalPlanned: true,
      period: {
        periodFrom: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        periodTo: moment().add(30, 'days').format('YYYY-MM-DD'),
      },
      periodPast: [
        {
          value: 180,
          name: '-180D',
          type: 'minus',
          enabled: false
        },
        {
          value: 60,
          type: 'minus',
          name: '-60D',
          enabled: false
        },
        {
          value: 30,
          type: 'minus',
          name: '-30D',
          enabled: false
        }
      ],
      periodFuture: [
        {
          value: 30,
          type: 'plus',
          name: '+30D',
          enabled: false
        },
        {
          value: 60,
          type: 'plus',
          name: '+60D',
          enabled: false
        },
        {
          value: 180,
          type: 'plus',
          name: '+180D',
          enabled: false
        }
      ],
      choosenPastButton: null,
      choosenFutureButton: null,
      hoursOrExpenses: {
        type: 'hours',
        name: 'Hours/Hours*rate'
      },
      hours: {
        type: 'hours',
        name: 'Hours'
      },
      expenses: {
        type: 'rates',
        name: 'Hours*rate'
      },
      jiraWorklogs: [],
      plannedWorkloads: {},
      dataLoaded: {
        worklogs: false,
        workloads: false
      }
    };
  },
  watch: {
    period: {
      handler: function (val) {
        this.loadWorklogsByPeriod({ periodFrom: moment(this.period.periodFrom).format('YYYY-MM-DD'), periodTo: moment(this.period.periodTo).format('YYYY-MM-DD') });
      },
      deep: true
    },
    worklogs: {
      handler: function (val) {
        const jiraWorklogs = this.worklogsByAuthor;
        for (const i in jiraWorklogs) {
          jiraWorklogs[i].user_id = i;
          jiraWorklogs[i].user_name = this.users[i].displayName;
        }
        const totalTemplate = {};
        for (const i in jiraWorklogs) {
          for (const k in jiraWorklogs[i]) {
            totalTemplate[k] = { expenses: 0, time: 0 };
          }
          break;
        }
        for (const usrKey in this.users) {
          const user = this.users[usrKey];
          if (usrKey in jiraWorklogs) {
            continue;
          } else if (user.enabled == 1) {
            jiraWorklogs[usrKey] = {};
            jiraWorklogs[usrKey].byProject = {};
            jiraWorklogs[usrKey].total = totalTemplate;
            jiraWorklogs[usrKey].user_id = usrKey;
            jiraWorklogs[usrKey].user_name = user.displayName;
          }
        }
        this.jiraWorklogs = Object.values(jiraWorklogs).sort((a, b) => { return (a.user_name > b.user_name) ? 1 : ((b.user_name > a.user_name) ? -1 : 0); });
        this.dataLoaded.worklogs = true;
        this.checkStatus;
      },
      deep: true
    },
    workloads: {
      handler: function (val) {
        this.dataLoaded.workloads = true;
        this.checkStatus;
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters('Worklogs', ['worklogsByAuthor', 'calendar', 'timeframe', 'offset', 'count', 'actualDate', 'worklogs']), // ...mapGetters('WorkloadPlans', ['workloadsByUserByYearweekByProject']),
    ...mapGetters('WorkloadPlans', ['workloadsByProjectByUserByYearweek',
      'workloadsByProjectByUserByMonth',
      'workloadsByProjectByUserByQuarter',
      'workloadsByProjectByUserByYear',
      'workloadsByUserByYearweekByProject',
      'workloads']),
    ...mapGetters('JiraUsers', ['users']),
    checkStatus() {
      if (this.dataLoaded.worklogs == true && this.dataLoaded.workloads == true) {
        this.calculateTotalPlanned();
      }
    },
    currentTimeframe: {
      get() {
        return this.timeframe;
      },
      set(value) {
        this.loadLogs({ timeframe: value, count: 4, offset: 0 });
      }
    },
  },
  methods: {
    ...mapActions({
      loadLogs: 'Worklogs/LOAD_JIRA_WORKLOGS', // map `this.add()` to `this.$store.dispatch('increment')`
      loadWorklogsByPeriod: 'Worklogs/LOAD_WORKLOGS_BY_PERIOD',
      loadPlannedWorkload: 'WorkloadPlans/LOAD_PLANNED_WORKLOADS'
    }),
    ...mapActions('JiraUsers', ['LOAD_JIRA_USERS']),
    calculateTotalPlanned() {
      let plannedWorkloads;
      switch (this.timeframe) {
        case 'week':
          plannedWorkloads = this.workloadsByUserByYearweekByProject;
          break;
        case 'month':
          plannedWorkloads = this.workloadsByUserByMonthByProject;
          break;
        case 'quarter':
          plannedWorkloads = this.workloadsByUserByQuarterByProject;
          break;
        case 'year':
          plannedWorkloads = this.workloadsByUserByYearByProject;
          break;
      }
      //                console.log('plannedWorkloads -> worklogs', plannedWorkloads);
      this.plannedWorkloads = plannedWorkloads;
    },
    toggleHoursOrExpenses(type) {
      if (type == 'hours') {
        this.hoursOrExpenses = this.expenses;
        this.showRateTime = true;
        this.showHours = false;
      } else {
        this.hoursOrExpenses = this.hours;
        this.showRateTime = false;
        this.showHours = true;
      }
    },
    changePeriodFromInput() {
      for (const i in this.periodPast) {
        this.periodPast[i].enabled = false;
      }
      this.choosenPastButton = null;
    },
    changePeriodToInput() {
      for (const i in this.periodFuture) {
        this.periodFuture[i].enabled = false;
      }
      this.choosenFutureButton = null;
    },
    changePeriodPast(button) {
      for (const i in this.periodPast) {
        if (this.periodPast[i].value == button.value) {
          this.periodPast[i].enabled = !this.periodPast[i].enabled;
        } else {
          this.periodPast[i].enabled = false;
        }
      }
      if (this.choosenPastButton) {
        if (this.choosenPastButton.value != button.value) {
          this.choosenPastButton = button;
          if (this.choosenFutureButton) {
            this.period = {
              periodFrom: moment().subtract(button.value, 'days').format('YYYY-MM-DD'),
              periodTo: moment().add(this.choosenFutureButton.value, 'days').format('YYYY-MM-DD')
            };
          } else {
            this.period = {
              periodFrom: moment().subtract(button.value, 'days').format('YYYY-MM-DD'),
              periodTo: moment().format('YYYY-MM-DD')
            };
          }
        } else {
          this.choosenPastButton = null;
          if (this.choosenFutureButton) {
            this.period = {
              periodFrom: moment().subtract(30, 'days').format('YYYY-MM-DD'),
              periodTo: moment().add(this.choosenFutureButton.value, 'days').format('YYYY-MM-DD')
            };
          } else {
            this.period = {
              periodFrom: moment().subtract(30, 'days').format('YYYY-MM-DD'),
              periodTo: moment().add(30, 'days').format('YYYY-MM-DD')
            };
          }
        }
      } else {
        this.choosenPastButton = button;
        if (this.choosenFutureButton) {
          this.period = {
            periodFrom: moment().subtract(button.value, 'days').format('YYYY-MM-DD'),
            periodTo: moment().add(this.choosenFutureButton.value, 'days').format('YYYY-MM-DD')
          };
        } else {
          this.period = {
            periodFrom: moment().subtract(button.value, 'days').format('YYYY-MM-DD'),
            periodTo: moment().format('YYYY-MM-DD')
          };
        }
      }
    },
    changePeriodFuture(button) {
      for (const i in this.periodFuture) {
        if (this.periodFuture[i].value == button.value) {
          this.periodFuture[i].enabled = !this.periodFuture[i].enabled;
        } else {
          this.periodFuture[i].enabled = false;
        }
      }
      if (this.choosenFutureButton) {
        if (this.choosenFutureButton.value != button.value) {
          this.choosenFutureButton = button;
          if (this.choosenPastButton) {
            this.period = {
              periodFrom: moment().subtract(this.choosenPastButton.value, 'days').format('YYYY-MM-DD'),
              periodTo: moment().add(button.value, 'days').format('YYYY-MM-DD')
            };
          } else {
            this.period = {
              periodFrom: moment().subtract(30, 'days').format('YYYY-MM-DD'),
              periodTo: moment().add(button.value, 'days').format('YYYY-MM-DD')
            };
          }
        } else {
          this.choosenFutureButton = null;
          if (this.choosenPastButton) {
            this.period = {
              periodFrom: moment().subtract(this.choosenPastButton.value, 'days').format('YYYY-MM-DD'),
              periodTo: moment().format('YYYY-MM-DD')
            };
          } else {
            this.period = {
              periodFrom: moment().subtract(30, 'days').format('YYYY-MM-DD'),
              periodTo: moment().add(30, 'days').format('YYYY-MM-DD')
            };
          }
        }
      } else {
        this.choosenFutureButton = button;
        if (this.choosenPastButton) {
          this.period = {
            periodFrom: moment().subtract(this.choosenPastButton.value, 'days').format('YYYY-MM-DD'),
            periodTo: moment().add(button.value, 'days').format('YYYY-MM-DD')
          };
        } else {
          this.period = {
            periodFrom: moment().subtract(30, 'days').format('YYYY-MM-DD'),
            periodTo: moment().add(button.value, 'days').format('YYYY-MM-DD')
          };
        }
      }
    },
    getWorklogData() {
      this.loadLogs({ timeframe: this.timeframe, count: this.count, offset: this.offset });
    },
    addOneWeek() {
      this.loadLogs({ timeframe: this.timeframe, count: this.count + 1, offset: this.offset });
    },
    increaseOffset() {
      this.loadLogs({ timeframe: this.timeframe, count: this.count, offset: this.offset + 1 });
    },
    decreaseOffset() {
      this.loadLogs({ timeframe: this.timeframe, count: this.count, offset: this.offset - 1 });
    },
    removeOneWeek() {
      this.loadLogs({ timeframe: this.timeframe, count: this.count - 1, offset: this.offset });
    },
    rateOnDate(date, userId) {
      return this.$store.getters['UserRates/ratesOnDate'](date, userId);
    },
    isCurrentWeek(date) {
      return date.index == this.actualDate;
    }
  },
  mounted() {
    this.LOAD_JIRA_USERS();
    this.loadPlannedWorkload();
    this.loadWorklogsByPeriod({ periodFrom: this.period.periodFrom, periodTo: this.period.periodTo });
    //            this.loadLogs({timeframe: 'week', count: 4, offset: 0});
    // this.getWorklogData();
    // this.loadSortedRates();
  },
};

</script>

<style scoped>
.table-condensed td {
  padding: 0;
}

.table-head-th {
  min-width: 80px;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 1;
  background: white;
}

.curweek {
  font-weight: bold;
}

.table-data {
  text-align: center;
}

.button-days {
  margin-right: 2px;
}

/* .userrow:hover {
        background-color: #efefef
    } */
/*.table {*/
/*height: 800px;*/
/*}*/
.table-view {
  overflow: scroll;
  position: relative;
  max-width: 1500px;
  max-height: 800px;
}

@media only screen and (min-width : 1304px) {
  .table-view {
    max-width: 1500px;
  }
}

@media only screen and (max-width : 1303px) {
  .table-view {
    max-width: 950px;
  }
}

/*thead .tr-full-width {*/
/*width: 100%;*/
/*display: inline-table;*/
/*!*height:100px;*!*/
/*table-layout: fixed;*/
/*}*/
/*tbody{*/
/*overflow-y: scroll;*/
/*max-height: 200px;*/
/*position: absolute;*/
/*}*/

/*thead .tr-full-width {*/
/*width: 100%;*/
/*display: inline-table;*/
/*!*height:100px;*!*/
/*table-layout: fixed;*/
/*}*/
.first-column {
  width: 200px;
  min-width: 200px;
  /*position: absolute;*/
  position: sticky;
  position: -webkit-sticky;
  left: 0;
  z-index: 2;
  top: 0;
  background: white;
}

.hours-enabled {
  color: red;
}

.rates-enabled {
  color: red;
}

.btn-success {
  background-color: #3a9d5d;
  border-color: #379558;
}
</style>
<style>
.worklogs-date-picker {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: #607d8b;
  padding: 0.5rem 0.75rem;
}
</style>
